import { render, staticRenderFns } from "./system-values.vue?vue&type=template&id=f7b448d2&"
import script from "./system-values.vue?vue&type=script&lang=js&"
export * from "./system-values.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports